import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLayout from "@/pages/admin/AdminLayout";
import EpisodesManager from "@/pages/admin/EpisodesManager";
import MediaLibrary from "@/pages/admin/MediaLibrary";
import SiteSettings from "@/pages/admin/SiteSettings";
import SocialLinksManager from "@/pages/admin/SocialLinksManager";
import Subscribers from "@/pages/admin/Subscribers";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="episodes" element={<EpisodesManager />} />
            <Route path="media" element={<MediaLibrary />} />
            <Route path="settings" element={<SiteSettings />} />
            <Route path="social-links" element={<SocialLinksManager />} />
            <Route path="subscribers" element={<Subscribers />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
